import { FormControlLabel, Icon, Switch, Tooltip } from "@mui/material";
import Loader from "examples/Loader";
import { useContext, useEffect, useState } from "react";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import axios from "axios";
import editIcon from "../../../assets/themeIcons/edit-icon.svg";
import { Delete } from "@mui/icons-material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import toast from "react-hot-toast";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const NormalTable = ({ data, openeditsaasmodel, handleRefresh }) => {
  const [agency] = useAgencyInfo();
  if (!Array.isArray(data)) {
    return <Loader />;
  }
  const AppService = useAppServices();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items per page

  // Filter data based on the search query
  const filteredData = data;

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const maxButtonsToShow = 5; // Number of pagination buttons to display at a time

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const [currentItems, setCurrentItems] = useState([]);
  const [openDeleteModel, SetOpenDeleteModel] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const handleOpenDeleteModel = (item) => {
    setSelectedDeleteItem(item);
    SetOpenDeleteModel(true);
  };

  useEffect(() => {
    setCurrentItems(filteredData.slice(indexOfFirstItem, indexOfLastItem));
  }, [data, currentPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const deletesaasmodel = async () => {
    const deletedItem = selectedDeleteItem;
    console.log(deletedItem, "deletedItemdeletedItem");
    if (!deletedItem) return;

    const payload = {
      _id: deletedItem?._id,
      agency_id: agency?._id,
      product_id: deletedItem?.product_id,
    };

    const { response } = await AppService.saas.deleteSaasConfigration({ payload });

    if (response?.success) {
      toast.success("Plan deleted successfully");
      handleRefresh();
      SetOpenDeleteModel(false);
      setSelectedDeleteItem(null); // Clear after delete
    } else {
      toast.error(response?.message || "Failed to delete plan");
    }
  };

  const copyFields = (value) => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        alert(`${value} Copied Successfully..!`);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  const handleToggleChange = async (item) => {
    // Optimistic Update: Update UI immediately
    const updatedItems = currentItems.map((currentItem) =>
      currentItem._id === item._id
        ? { ...currentItem, isenable_account: !item.isenable_account }
        : currentItem
    );
    setCurrentItems(updatedItems); // Assuming `setCurrentItems` manages the local state for `currentItems`

    // Prepare payload
    const payload = {
      _id: item?._id,
      agency_id: agency?._id,
      product_id: item?.product_id,
      isenable_account: !item?.isenable_account,
    };

    try {
      // Make the API call
      const { response } = await AppService.saas.showonaccountlevel({ payload });

      if (!response) {
        // Rollback if API fails
        setCurrentItems(currentItems);
        console.error("Failed to update toggle on the server.");
      }
    } catch (error) {
      // Rollback in case of an error
      setCurrentItems(currentItems);
      console.error("Error updating toggle:", error);
    }
  };

  // Calculate start and end of pagination buttons
  const startPage = Math.max(currentPage - Math.floor(maxButtonsToShow / 2), 1);
  const endPage = Math.min(startPage + maxButtonsToShow - 1, totalPages);

  const onDragEnd = async (result) => {
    if (!result.destination) return;
    const reordered = reorder(currentItems, result.source.index, result.destination.index);
    setCurrentItems(reordered);

    const reorderedPayload = reordered.map((item, index) => ({
      _id: item._id,
      order: index,
    }));

    const payload = {
      reorderItems: reorderedPayload,
    };

    await AppService.saas.ReOrderPlan({
      payload,
    });
  };

  return (
    <>
      <div className="w-100">
        <table className="w-100" style={{ borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#F7F7F7", borderRadius: "18px" }}>
              <th className="p-20-px w-20-per text-left">Plan Name</th>
              <th className="p-20-px w-15-per text-left"></th>
              <th className="p-20-px w-12-per text-left">Monthly</th>
              <th className="p-20-px w-12-per text-left">Annual</th>
              <th className="p-20-px w-12-per text-left"></th>
              <th className="p-20-px w-10-per text-left">Active</th>
              <th className="p-20-px w-10-per text-left">Edit</th>
              <th className="p-20-px w-9-per text-left">Delete</th>
            </tr>
          </thead>

          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" direction="vertical">
              {(provided) => (
                <tbody ref={provided.innerRef} {...provided.droppableProps}>
                  {currentItems?.length > 0 &&
                    currentItems.map((item, index) => (
                      <Draggable key={item._id} draggableId={String(item._id)} index={index}>
                        {(provided) => (
                          <tr
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            key={index}
                            style={{
                              borderBottom: "1px solid #DDDDDD",
                              background: "white",
                              ...provided.draggableProps.style,
                            }}
                          >

                            {/* Plan Name */}
                            <td className="p-20-px text-left w-12-per">
                              <div style={{ display: "flex", gap: "20px" }}>
                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr",
                                    gap: 2,
                                    alignItems: "center",
                                    justifyItems: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      width: 4,
                                      height: 4,
                                      borderRadius: "50%",
                                      background: "#999",
                                    }}
                                  />
                                  <span
                                    style={{
                                      width: 4,
                                      height: 4,
                                      borderRadius: "50%",
                                      background: "#999",
                                    }}
                                  />
                                  <span
                                    style={{
                                      width: 4,
                                      height: 4,
                                      borderRadius: "50%",
                                      background: "#999",
                                    }}
                                  />
                                </div>
                                <span style={{ width: "350px" }}>{item.product_name}</span>
                                <span className="alert-default-new">DEFAULT</span>
                              </div>
                            </td>

                            <td className="p-20-px w-12-per text-left">
                              <div className="d-flex justify-content-between">
                                {item?.apps?.includes("AI Social App") && (
                                  <div className="everyicon-z">
                                    <div className="ml-2 mr-2 mb-2 ">
                                      <div className="border-gray-300 border rounded-full h-9 w-9 p-2">
                                        {/* SVG 1 */}
                                        <svg
                                          width="21"
                                          height="18"
                                          viewBox="0 0 21 18"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M9.625 4.37413C11.7206 5.01375 13.3612 6.65525 13.9991 8.75C14.6405 6.65438 16.2811 5.01463 18.375 4.375C16.2811 3.73537 14.6405 2.09562 13.9991 0C13.3612 2.09475 11.7206 3.7345 9.625 4.37413ZM15.75 10.4991C17.0074 10.8824 17.9917 11.8676 18.3741 13.125C18.7591 11.8676 19.7435 10.8833 21 10.5C19.7435 10.1159 18.7591 9.13237 18.3741 7.875C17.9917 9.1315 17.0074 10.1159 15.75 10.4991ZM10.5 15.3125C11.5482 15.6319 12.3681 16.4526 12.6866 17.5C13.0069 16.4517 13.8276 15.6319 14.875 15.3125C13.8276 14.9923 13.0077 14.1733 12.6866 13.125C12.3681 14.1724 11.5482 14.9923 10.5 15.3125ZM5.24913 4.375C4.4835 6.88888 2.51213 8.85938 0 9.62588C2.5165 10.3959 4.4835 12.3629 5.2535 14.8794C6.01912 12.3646 7.9905 10.3959 10.5 9.62588C7.9905 8.86112 6.01912 6.88975 5.24913 4.375Z"
                                            fill="#757575"
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {item?.apps.includes("AI Celender App") && (
                                  <div className="everyicon-z">
                                    <div className="ml-2 mr-2 mb-2 ">
                                      <div className="border-gray-300 border rounded-full h-9 w-9 p-2">
                                        {/* SVG 2 */}
                                        <svg
                                          width="21"
                                          height="21"
                                          viewBox="0 0 21 21"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <mask
                                            id="mask0_391_66"
                                            style={{ maskType: "luminance" }}
                                            maskUnits="userSpaceOnUse"
                                            x="0"
                                            y="0"
                                            width="21"
                                            height="21"
                                          >
                                            <path
                                              d="M20.2314 0.929688H0.231445V20.9297H20.2314V0.929688Z"
                                              fill="white"
                                            />
                                          </mask>
                                          <g mask="url(#mask0_391_66)">
                                            <path
                                              d="M16.0648 4.26172H4.39811C3.47764 4.26172 2.73145 5.00791 2.73145 5.92839V17.5951C2.73145 18.5155 3.47764 19.2617 4.39811 19.2617H16.0648C16.9853 19.2617 17.7314 18.5155 17.7314 17.5951V5.92839C17.7314 5.00791 16.9853 4.26172 16.0648 4.26172Z"
                                              stroke="#757575"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                            <path
                                              d="M13.5645 2.59766V5.93099"
                                              stroke="#757575"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                            <path
                                              d="M6.89844 2.59766V5.93099"
                                              stroke="#757575"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                            <path
                                              d="M2.73145 9.26172H17.7314"
                                              stroke="#757575"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </td>

                            <td className="p-20-px w-12-per text-left">
                              {item?.currency_symbol}
                              {item.monthly_amount ? item.monthly_amount / 100 : 0}
                            </td>

                            <td className="p-20-px w-12-per text-left">
                              {item?.currency_symbol}
                              {item.yearly_amount ? item.yearly_amount / 100 : 0}
                            </td>

                            <td className="p-20-px w-12-per text-left"></td>
                            {/* <td className="p-20-px w-5-per text-left"></td> */}

                            <td className="p-40-px w-10-per text-left">
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={item.isenable_account || false}
                                    onChange={() => handleToggleChange(item)}
                                  />
                                }
                                label=""
                              />
                            </td>

                            <td
                              className="p-20-px w-10-per text-left cursor-pointer"
                              onClick={() => openeditsaasmodel(item)}
                            >
                              <img width={20} src={editIcon} />
                            </td>

                            <td
                              className="p-20-px w-10-per text-left cursor-pointer"
                              onClick={() => handleOpenDeleteModel(item)}
                            >
                              <Icon style={{ marginLeft: "10px" }}>
                                <Delete />
                              </Icon>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </DragDropContext>
        </table>
      </div>

      {openDeleteModel && (
        <div className="modal-zz-confirm">
          <div
            className="scrollable-modal-content bg-white  rounded"
            style={{ position: "relative" }}
          >
            <h2 className="wrning-heading">Warning:</h2>
            <span className="crossison" onClick={() => SetOpenDeleteModel(false)}>
              X
            </span>
            <div className="container mt-4">
              <div className="flex justify-center">
                <div className="w-full lg:w-3/4">
                  <div className=" bg-white shadow-lg rounded-lg p-6">
                    <div>
                      <p className="warning-text">
                        Deleting this plan may affect existing users who are currently subscribed to
                        it. This action could result in loss of access or service disruption. Please
                        proceed with caution.
                      </p>
                    </div>

                    <div
                      className="d-flex mt-6"
                      style={{ justifyContent: "flex-end", gap: "15px" }}
                    >
                      <button
                        className="closeBtn"
                        style={{ marginTop: "10px" }}
                        type="button"
                        onClick={() => SetOpenDeleteModel(false)}
                      >
                        Close
                      </button>

                      <button
                        className="deletebtn"
                        style={{ marginTop: "10px" }}
                        type="button"
                        onClick={deletesaasmodel}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Pagination Controls */}
      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <button
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          style={{
            padding: "8px 16px",
            margin: "0 5px",
            backgroundColor: "white",
            color: "black",
            border: "1px solid black",
            borderRadius: "4px",
            cursor: currentPage === 1 ? "not-allowed" : "pointer",
            opacity: currentPage === 1 ? 0.6 : 1,
          }}
        >
          Previous
        </button>

        {[...Array(endPage - startPage + 1)].map((_, index) => {
          const pageNumber = startPage + index;
          return (
            <button
              key={pageNumber}
              onClick={() => handlePageChange(pageNumber)}
              style={{
                padding: "8px 16px",
                margin: "0 5px",
                backgroundColor: pageNumber === currentPage ? "black" : "white",
                color: pageNumber === currentPage ? "white" : "black",
                border: pageNumber === currentPage ? "1px solid white" : "1px solid black",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              {pageNumber}
            </button>
          );
        })}

        <button
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          style={{
            padding: "8px 16px",
            margin: "0 5px",
            backgroundColor: "white",
            color: "black",
            border: "1px solid black",
            borderRadius: "4px",
            cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            opacity: currentPage === totalPages ? 0.6 : 1,
          }}
        >
          Next
        </button>
      </div>
    </>
  );
};
export default NormalTable;
